import axios from "axios";
import { contentConstants } from "./content-constants";
import { history } from "../../../../helpers/index";
import { routePaths } from "../../../config/route-paths";
import { store } from "../../../../helpers/store";
import { config } from "../../../../enviroment";
import { pathActions } from "../../../../actions/path.actions";

const faqs = (languageCode, categoryCode) => async (dispatch) => {
  try {
    const res = await axios.post(config.urls.ADMIN_SERVICE_BASE_URL, {
      query:
        `{getContents(input:{languageCode:"` +
        languageCode +
        `",categoryCode:"` +
        categoryCode +
        `"})}`,
    });
    dispatch({
      type: contentConstants.FAQS_SUBMIT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: contentConstants.FAQS_SUBMIT_FAILURE,
      payload: error.message,
    });
  }
};

const links = (languageCode, categoryCode) => async (dispatch) => {
  try {
    const res = await axios.post(config.urls.ADMIN_SERVICE_BASE_URL, {
      query:
        `{getContents(input:{languageCode:"` +
        languageCode +
        `",categoryCode:"` +
        categoryCode +
        `"})}`,
    });
    dispatch({
      type: contentConstants.LINKS_SUBMIT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: contentConstants.LINKS_SUBMIT_FAILURE,
      payload: error.message,
    });
  }
};

let keyword=new URLSearchParams(window.location.search).get("q");
const searchSubmit = (keyword) => async (dispatch) => {
  dispatch({
    type: contentConstants.SEARCH_SUBMIT_START,
    keyword,
    payload: {},
  });
  if (keyword) {
    history.push(routePaths.SEARCH_RESULTS+"?q="+keyword);
    dispatch(pathActions.getLocationPath(routePaths.SEARCH_RESULTS));
  }
 
};

export { searchSubmit, faqs, links };
